import { IS_SERVER_ENVIRONMENT, isApplicationLikeId, isMicroFrontendLikeId, } from "@aviv-unified-frontend/internal";
import { registerApplication, registerMicroFrontend, } from "@aviv-unified-frontend/runtime/monitoring";
import { createLifecycleContext } from "@aviv-unified-frontend/runtime/lifecycle";
import { registry } from "../../configs/registry";
import { GeneralErrorPage as FallbackComponent } from "../pages/errors";
import { logger } from "./logger";
/**
 * Create lifecycle context for the Shell with specific FallbackComponent and Initialization function
 */
export const createShellLifecycleContext = () => createLifecycleContext({
    FallbackComponent,
    onInitialization: ({ id, version }) => {
        const getVersion = (id, fallbackVersion = version) => {
            if (!version) {
                // Warn only on the browser side to avoid log pollution server side where all remote entries are eagerly loaded at Shell initialization.
                if (!IS_SERVER_ENVIRONMENT) {
                    logger.debug([
                        `The \`version\` field is missing while using \`createApplication\` or \`createMicroFrontend\` for component \`${id}\`.`,
                        "As a fallback the registry version is used.",
                        "Make sure to source the version from your component's `package.json` file.",
                    ].join("\n"));
                }
                return fallbackVersion;
            }
            return version;
        };
        /**
         * `registerApplication` calls `datadogRum.startView` under the hood.
         * `startView` call must be done once in a given web page since only the latest call is taken into account to set the view context.
         * The application is the sole responsible for this single call (which makes the most sense since most of the Core Web Vitals (FCP, LCP) are intrinsic to the page globally).
         * To prevent polluting application error logs with micro-frontend ones (if displayed in the page), errors are filtered and proxied to the appropriated micro-frontend
         * service name thanks to `beforeSend` hook allowing us to get rid of the double `startView` calls issue in the same page..
         */
        if (isApplicationLikeId(id)) {
            const applicationVersion = getVersion(id, String(registry.getApplicationFromId(id)?.version));
            registerApplication({ id, version: applicationVersion });
        }
        if (isMicroFrontendLikeId(id)) {
            const microFrontendVersion = getVersion(id, String(registry.getMicroFrontendFromId(id)?.version));
            registerMicroFrontend({ id, version: microFrontendVersion });
        }
    },
});
